export function numberMask(num: string) {
	return num.replace(/\D/g, "");
}